// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import chatReducer from "./slices/chat";

import userReducer from "./slices/user";
import snackbarReducer from "./slices/snackbar";
import cartReducer from "./slices/cart";
import menuReducer from "./slices/menu";
import accountReducer from "./accountReducer";
import user1Reducer from "./userReducer";
import deptReducer from "./deptReducer";
import settingReducer from "./settingReducer";
import languageReducer from "./languageReducer";
import cmsReducer from "./cmsReducer";
import alertReducer from "./alertReducer";
import propertyReducer from "./propertyReducer";
import staffReducer from "./staffReducer";
import reportPropertyReducer from "./reportPropertyReducer";
import dashboardReducer from "./dashboardReducer";
import propertyOwnerReducer from "./propertyOwnerReducer";
import staffSupportReducer from "./staffSupportReducer";
import emailTemplateReducer from "./emailTemplateReducer";
import propertyRequestReducer from "./propertyRequestReducer";
import notificationReducer from "./notificationReducer";
import replyReducer from "./staffSupportReply";
import headerNotificationReducer from "./headerNotificationReducer";
import testimonialReducer from "./testimonialReducer";
import partnersReducer from "./partnersReducer";
import firebaseChatReducer from "./chatReducer";
import propertyFieldReducer from "./propertyFieldReducer";
import agencyReducer from "./agencyReducer";
import contactReducer from "./contactReducer";
import questionAnswerReducer from "./questionAnswerReducer";
import tenantReducer from "./TenantListReducer";
import subscriptionReducer from "./subscriptionReducer";
import adsReducer from "./adsReducer";
import rentalContractReducer from "./rentalContractReducer";
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  
  chat: chatReducer,
  rental:rentalContractReducer,
  menu: menuReducer,
  auth: accountReducer,
  userAll: user1Reducer,
  departmentAll: deptReducer,
  setting: settingReducer,
  language: languageReducer,
  cms: cmsReducer,
  alert: alertReducer,
  user: userReducer,
  property: propertyReducer,
  staff: staffReducer,
  report: reportPropertyReducer,
  dashboard: dashboardReducer,
  propertyOwner: propertyOwnerReducer,
  staffSupport: staffSupportReducer,
  emailTemplate: emailTemplateReducer,
  propertyRequest: propertyRequestReducer,
  notifications: notificationReducer,
  allReply: replyReducer,
  headerNotification: headerNotificationReducer,
  testimonials: testimonialReducer,
  partners: partnersReducer,
  chats: firebaseChatReducer,
  propertyField: propertyFieldReducer,
  agency: agencyReducer,
  contact: contactReducer,
  question: questionAnswerReducer,
  tenant: tenantReducer,
  subscription: subscriptionReducer,
  ads: adsReducer,
});

export default reducer;
